import { filterAccessibleItems } from "app/components/React/QuickSearch/pageData/filterAccessibleItems";
import type { QuickSearchCatalogPage } from "app/components/React/QuickSearch/pageData/getQuickSearchCatalogPages";
import type { SidebarAccessMap } from "app/components/React/QuickSearch/pageData/getSidebarAccessMap";

const getCatalogPageUiRouterState = (page: QuickSearchCatalogPage): string | undefined => page.uiRouterState;

export const getAccessibleQuickSearchCatalogPages = (
    pages: QuickSearchCatalogPage[],
    sidebarAccessMap: SidebarAccessMap,
): QuickSearchCatalogPage[] =>
    filterAccessibleItems(pages, sidebarAccessMap, getCatalogPageUiRouterState).map(({ item, isLocked, hookKey }) =>
        isLocked ? { ...item, isLocked: true, hookKey } : item,
    );
